import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingButton from "./LoadingButton";

/**
 * A button wrapper that uses the progress of a promise to show a loading indicator
 */
export default class PromiseButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      mounted: true,
    };
  }

  componentWillUnmount() {
    this.state.mounted = false;
  }

  onClick(e) {
    e.preventDefault();

    const { loading } = this.state;
    const { onClick } = this.props;

    if (loading) {
      return;
    }

    const promise = onClick();

    if (promise) {
      this.setState({ loading: true });

      promise.then(this.disableLoadingIndicator.bind(this)).catch(this.disableLoadingIndicator.bind(this));
    }
  }

  disableLoadingIndicator() {
    const { mounted } = this.state;

    if (mounted) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading } = this.state;
    const { onClick, className, ...props } = this.props;

    return <LoadingButton loading={loading} className={className} onClick={e => this.onClick(e)} {...props} />;
  }
}

PromiseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};
